var CompanyServiceType;
(function (CompanyServiceType) {
    CompanyServiceType["SHIPPER"] = "Shipper";
    CompanyServiceType["FLEET_OWNER"] = "Fleet Owner";
    CompanyServiceType["TRANSPORT_CONTRACTOR"] = "Transport Contractor";
    CompanyServiceType["AGENT_BROKER"] = "Agent/Broker";
    CompanyServiceType["DEPRECATED_SERVICE_TYPE"] = "Transport Contractor, Agent/Broker";
})(CompanyServiceType || (CompanyServiceType = {}));
const CompanyServiceTypeMap = {
    [CompanyServiceType.SHIPPER]: "Shipper",
    [CompanyServiceType.FLEET_OWNER]: "Truck Owner / Driver",
    [CompanyServiceType.TRANSPORT_CONTRACTOR]: "Transporter",
    [CompanyServiceType.AGENT_BROKER]: "Transporter",
    [CompanyServiceType.DEPRECATED_SERVICE_TYPE]: "Transport Contractor, Agent/Broker"
};
var ServiceTypeId;
(function (ServiceTypeId) {
    ServiceTypeId[ServiceTypeId["SHIPPER"] = 1] = "SHIPPER";
    ServiceTypeId[ServiceTypeId["TRUCKER"] = 2] = "TRUCKER";
    ServiceTypeId[ServiceTypeId["TRANSPORTER"] = 3] = "TRANSPORTER";
})(ServiceTypeId || (ServiceTypeId = {}));
const ServiceTypeIdName = {
    [ServiceTypeId.SHIPPER]: "Shipper",
    [ServiceTypeId.TRUCKER]: "Trucker",
    [ServiceTypeId.TRANSPORTER]: "Transporter"
};
const CommonServiceType = [
    CompanyServiceType.TRANSPORT_CONTRACTOR,
    CompanyServiceType.SHIPPER,
    CompanyServiceType.FLEET_OWNER
];
function getServiceTypeId(serviceType) {
    switch (serviceType) {
        case CompanyServiceType.SHIPPER:
            return ServiceTypeId.SHIPPER;
        case CompanyServiceType.FLEET_OWNER:
            return ServiceTypeId.TRUCKER;
        case CompanyServiceType.TRANSPORT_CONTRACTOR:
        case CompanyServiceType.AGENT_BROKER:
        case CompanyServiceType.DEPRECATED_SERVICE_TYPE:
            return ServiceTypeId.TRANSPORTER;
        default:
            return undefined;
    }
}

export { CommonServiceType, CompanyServiceType, CompanyServiceTypeMap, ServiceTypeId, ServiceTypeIdName, getServiceTypeId };
//# sourceMappingURL=serviceTypeId.js.map
